import { combineEpics } from "redux-observable";

import { deleteCookieEpic, readCookieEpic, saveCookieEpic } from "./auth";

export const rootEpic = combineEpics(deleteCookieEpic, readCookieEpic, saveCookieEpic);
